import { IconName } from 'ui/components'

import * as SC from './styles'

type Props = {
  url?: string
  onClick?: () => void
}

export const DetailsItem = (props: Props) => {
  const { url, onClick } = props

  return (
    <SC.DetailsItem
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
      data-qa={`table-action-DETAILS`}
    >
      <SC.WrappedIcon name={IconName.INFO_OUTLINE} />
      <span>Details</span>
    </SC.DetailsItem>
  )
}
